import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@mui/material';

interface AmountProps {
  regularAmount: number;
  amount: number;
}

export const Amount: FunctionComponent<AmountProps> = ({
  regularAmount,
  amount,
}) => {
  return (
    <Box
      my={{
        xs: 1,
        sm: 2,
      }}
      display="flex"
      flexDirection="column"
      alignContent="center"
    >
      {regularAmount && (
        <Typography
          component="p"
          variant="h2"
          color="error"
          align="center"
          style={{
            textDecoration: 'line-through',
            textDecorationColor: 'rgba(0,0,0,0.54)',
            lineHeight: 1,
          }}
        >
          {regularAmount / 100 ?? '?'} zł
        </Typography>
      )}
      <Typography
        component="p"
        variant="h4"
        align="center"
        style={{ fontWeight: 400 }}
      >
        {amount / 100 ?? '?'} zł
      </Typography>
    </Box>
  );
};

export default Amount;
